export default __webpack_public_path__ + "static/media/star_5.714d8821.svg";